define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var UserContext = /** @class */ (function () {
        function UserContext() {
        }
        UserContext.currentUser = function () {
            var self = this;
            if (!self.userContext) {
                self.userContext = window['userContext'];
                self.userContext.rolesMap = {};
                ko.utils.arrayForEach(self.userContext.roles, function (item) {
                    self.userContext.rolesMap[item.Value] = item.Value;
                });
            }
            return self.userContext;
        };
        UserContext.hasAccess = function (roles) {
            var self = this;
            var rolesArray = roles.split(',');
            for (var i = 0; i < rolesArray.length; i++) {
                var role = rolesArray[i];
                if (self.currentUser().rolesMap[role]) {
                    return true;
                }
            }
            return false;
        };
        return UserContext;
    }());
    return UserContext;
});
//# sourceMappingURL=UserContext.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/UserContext.js
// module id = 5
// module chunks = 2